import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ToursPage = lazy(() => import('../pages/tours/page'));
const TourDetailPage = lazy(() => import('../pages/tour-detail/page'));
const DubaiToursPage = lazy(() => import('../pages/dubai-tours/page'));
const AbuDhabiToursPage = lazy(() => import('../pages/abu-dhabi-tours/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/tours',
    element: <ToursPage />
  },
  {
    path: '/tour/:tourId',
    element: <TourDetailPage />
  },
  {
    path: '/dubai-tours',
    element: <DubaiToursPage />
  },
  {
    path: '/abu-dhabi-tours',
    element: <AbuDhabiToursPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/booking',
    element: <BookingPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
